import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/components/layout'
import workbench from '@/views/workbench/index'
import franchiseManagement from '@/views/franchiseManagement/index'
import storeManagement from '@/views/storeManagement/index'
import platformProducts from '@/views/platformProducts/index'
import merchantProductManagement from '@/views/merchantProductManagement/index'
import personnelManagement from '@/views/personnelManagement/index'
import rolePermissions from '@/views/rolePermissions/index'
import employeeLog from '@/views/employeeLog/index'
import fundAccount from '@/views/fundAccount/index'
import supplierManagement from '@/views/supplierManagement/index'
import customerManagement from '@/views/customerManagement/index'
import prePurchaseOrder from '@/views/prePurchaseOrder/index'
import purchaseOrder from '@/views/purchaseOrder/index'
import inventoryFlow from '@/views/inventoryFlow/index'
import inventoryCheck from '@/views/inventoryCheck/index'
import salesManagement from '@/views/salesManagement/index'
import productTraceability from '@/views/productTraceability/index'
import goodsTransferManagement from '@/views/goodsTransferManagement/index'
import billDetails from '@/views/billDetails/index'
import assetSnapshot from '@/views/assetSnapshot/index'
import mergeReceiptsPayments from '@/views/mergeReceiptsPayments/index'
import mergeReceiptsNotPayments from '@/views/mergeReceiptsNotPayments/index'
import productAnalysis from '@/views/productAnalysis/index'
import inventoryAnalysis from '@/views/inventoryAnalysis/index'
import procurementAnalysis from '@/views/procurementAnalysis/index'
import salesAnalysis from '@/views/salesAnalysis/index'
import employeePerformanceAnalysis from '@/views/employeePerformanceAnalysis/index'
import takeoutanalysis from '@/views/takeoutanalysis/index'
import customerAnalysis from '@/views/customerAnalysis/index'
import franchiseInvoice from '@/views/franchiseInvoice/index'
import productShelfLife from '@/views/productShelfLife/index'
import ProductTransaction from '@/views/ProductTransaction/index'
import weChatOfficialAccountConfiguration from '@/views/underDevelopment/index'
import productClassification from '@/views/productClassification/index'
import regionalManagement from '@/views/regionalManagement/index'
import quotationManagement from '@/views/quotationManagement/index'
import individualOrderManagement from '@/views/individualOrderManagement/index'
import storeProductManagement from "@/views/storeProductManagement/index"
import onlineBanking from "@/views/onlineBanking/index"
import weChatUsers from "@/views/weChatUsers/index"
import employeeindex from "@/views/employeeindex/index"
import wxRoomManagement from "@/views/wxRoomManagement/index"
import tradeManagement from "@/views/tradeManagement/index"
import attendanceAnalysis from "@/views/attendanceAnalysis/index"
import userMsg from "@/views/userMsg/index"
import brandManagement from "@/views/brandManagement/index"
import labelManagement from "@/views/labelManagement/index"
import ws from "@/views/ws/index"
import pendingReplenishmentOrder from "@/views/pendingReplenishmentOrder/index"
import inquirySheet from '@/views/inquirySheet/index'
import inventoryLogs from '@/views/inventoryLogs'
import stockTarget from '@/views/stockTarget/index'
import productNameTraining from '@/views/productNameTraining'
import groupChatManagement from "@/views/groupChatManagement"
import { ROLE_IDS } from '@/constants/roles'


Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/userMsg',
      component: () => import('@/views/userMsg/index'),
      hidden: true,
      meta: { title: '' }, // 每一个路由都要有 meta.title ，不然路由监视部分会报错走不下去
    },
    {
      path: '/login',
      component: () => import('@/views/login/index'),
      hidden: true,
      meta: { title: '' }, // 每一个路由都要有 meta.title ，不然路由监视部分会报错走不下去
    },
    {
      path: '/SY',
      component: () => import('@/views/logisticsCode/index'),
      hidden: true,
      meta: { title: '物流码' }, // 每一个路由
    },
    // {
    //   path: "/bigDataScreen",
    //   component: () => import('@/views/bigDataScreen/index'),
    //   hidden: true,
    //   meta: { title: '数据大屏' }, // 每一个路由
    // },
    {
      path: "/storeLargeScreen",
      component: () => import('@/views/storeLargeScreen/index'),
      hidden: true,
      meta: { title: '门店大屏' }, // 每一个路由
    },

    // 路由名对应权限菜单名，如果没有，则单独放一个 menu，既：如果meta 无menu字段，就取title
    // {
    //   path: '/',
    //   component: layout,
    //   meta: { title: '首页', visiable: false, icon: 'icon-gongzuotai', roles: [ 1,2, 3, 9] },
    //   children: [
    //     {
    //       path: '/', // 或者指定一个具体的路径，如 '/procurement'
    //       name: '/',
    //       component: workbench,
    //       meta: { title: '首页', visiable: true, icon: 'icon-gongzuotai', roles: [1,2,3,9] },
    //        hidden: true
    //     },
    //   ],
    //   hidden: false
    // },
    {
      path: '/',
      component: layout,
      meta: { title: '首页', visiable: false, icon: 'icon-gongzuotai', roles: [1, 2, 3, 9] },
      children: [
        {
          path: '/',
          name: '/',
          meta: { title: "首页", roles: [1, 2, 3, 9] }, // 特权用户看这个
          component: workbench,
          hidden: true
        },
        {
          path: '/employeeindex',
          name: 'employeeindex',
          meta: { title: "首页", hidden: true, roles: [4], menu: '员工首页' }, // 普通用户看这个
          component: employeeindex,
          hidden: true
        },
      ],
      hidden: true
    },
    {
      path: '/purchasing',
      component: layout,
      meta: { title: "采购", visiable: true, icon: "icon-caigoujihua", roles: [2, 3, 9] },
      children: [
        {
          path: '/prePurchaseOrder',
          name: 'prePurchaseOrder',
          meta: { title: "预采购单", visiable: false, roles: [2, 3, 9] },
          component: prePurchaseOrder,
          hidden: true
        }, {
          path: '/purchaseOrder',
          name: 'purchaseOrder',
          meta: { title: "采购单", visiable: true, roles: [2, 3, 9] },  //采购管理 & 采购记录
          component: purchaseOrder,
          hidden: true
        }, {
          path: '/goodsTransferManagement',
          name: 'goodsTransferManagement',
          meta: { title: "调货单", visiable: true, roles: [2, 3, 9] },  //调货管理  & 入库确认单
          component: goodsTransferManagement,
          hidden: true
        }, {
          path: '/pendingReplenishmentOrder',
          name: 'pendingReplenishmentOrder',
          meta: { title: "待补货单", visiable: true, roles: [2, 3, 9] },  //调货管理  & 入库确认单
          component: pendingReplenishmentOrder,
          hidden: true
        }, {
          path: '/inquirySheet',
          name: 'inquirySheet',
          meta: { title: "询价单", visiable: true, roles: [2, 3, 9] },  //调货管理  & 入库确认单
          component: inquirySheet,
          hidden: true

        }

      ],
      hidden: true
    },
    {
      path: '/productManagement',
      component: layout,
      meta: { title: "产品", icon: "icon-shangpin", visiable: false, roles: [2, 3, 9, ROLE_IDS.TAKEOUT_UNIT], menu: '产品' },
      children: [
        {
          path: '/merchantProductManagement',
          name: 'merchantProductManagement',
          meta: { title: "产品管理", roles: [1, 2, 3, 9, ROLE_IDS.TAKEOUT_UNIT], menu: '产品管理' }, // 特权用户看这个
          component: merchantProductManagement,
          hidden: true
        },
        // {
        //   path: '/storeProductManagement',
        //   name: 'storeProductManagement',
        //   meta: { title: "产品管理", roles: [9], menu: '产品管理' }, // 普通用户看这个
        //   component: storeProductManagement,
        //   hidden: true
        // },
        {
          path: '/productTraceability',
          name: 'productTraceability',
          meta: { title: "产品溯源", roles: [2, 3, 9], menu: '产品溯源' }, // 需要后补
          component: productTraceability,
          hidden: true
        }, {
          path: '/productShelfLife',
          name: 'productShelfLife',
          meta: { title: "产品保质期", roles: [2, 3, 9], menu: '产品保质期' }, //需要后补
          component: productShelfLife,
          hidden: true
        },
        {
          path: '/ProductTransaction',
          name: 'ProductTransaction',
          meta: { title: "交易记录", roles: [1, 2, 3, 9], menu: '交易记录' }, // 特权用户看这个
          component: ProductTransaction,
          hidden: true
        },
      ],
      hidden: true
    },
    {
      path: '/inventoryManagement',
      component: layout,
      meta: { title: "库存", icon: "icon-jifenpeizhi", roles: [2, 3, 9] },
      children: [{
        path: '/inventoryFlow',
        name: 'inventoryFlow',
        meta: { title: "库存查询", roles: [2, 3, 9] },  //库存列表&库存流水
        component: inventoryFlow,
        hidden: true
      }, {
        path: '/inventoryCheck',
        name: 'inventoryCheck',
        meta: { title: "库存盘点", roles: [2, 3, 9] },
        component: inventoryCheck,
        hidden: true
      },
       {

        path: '/inventoryLogs',
        name: 'inventoryLogs',
        meta: { title: "库存日志", roles: [2, 3, 9] },
        component: inventoryLogs,
        hidden: true
      }
      ,{
        path: '/stockTarget',
        name: 'stockTarget',
        meta: { title: "目标库存", roles: [2, 3, 9] },
        component: stockTarget,
        hidden: true
      }
    ],
      hidden: true
    },
    {
      path: '/salesManagement',
      component: layout,
      meta: {
        title: "销售", icon: "icon-xiaoshoudan", roles: [2, 3, 9, ROLE_IDS.TAKEOUT_UNIT]
      },
      children: [{
        path: '/salesManagement',
        name: 'salesManagement',
        meta: { title: "销售单", roles: [2, 3, 9, ROLE_IDS.TAKEOUT_UNIT] },  //销售记录
        component: salesManagement,
        hidden: true
      }, {
        path: '/individualOrderManagement',
        name: 'individualOrderManagement',
        meta: { title: "外卖单", roles: [2, 3, 9] },  //散客订单管理
        component: individualOrderManagement,
        hidden: true
      }, {
        path: '/quotationManagement',
        name: 'quotationManagement',
        meta: { title: "报价单", roles: [2, 3, 9] },  //报价管理
        component: quotationManagement,
        hidden: true
      }],
      hidden: true
    },
    {
      path: '/financialManagement',
      component: layout,
      meta: { title: "财务", icon: "icon-caiwu-xianxing", roles: [2, 3, 9] },
      children: [
        {
          path: '/mergeReceiptsPayments',
          name: 'mergeReceiptsPayments',
          meta: { title: "应收款", roles: [2, 3, 9] },
          component: mergeReceiptsPayments,
          hidden: true
        }, {
          path: '/mergeReceiptsNotPayments',
          name: 'mergeReceiptsNotPayments',
          meta: { title: "应付款", roles: [2, 3, 9] },
          component: mergeReceiptsNotPayments,
          hidden: true
        }, {
          path: '/billDetails',
          name: 'billDetails',
          meta: { title: "财务流水", roles: [2, 3, 9] },  //账单明细
          component: billDetails,
          hidden: true
        },
        {
          path: '/assetSnapshot',
          name: 'assetSnapshot',
          meta: { title: "资产快照", roles: [2, 3, 9] },
          component: assetSnapshot,
          hidden: true
        },
        {
          path: '/franchiseInvoice',
          name: 'franchiseInvoice',
          meta: { title: "加盟账单", roles: [1, 2, 3, 4, 9] },
          component: franchiseInvoice,
          hidden: true
        }
      ],
      hidden: true
    },
    {
      path: '/dataAnalysis',
      component: layout,
      meta: { title: "报表", icon: "icon--shuju-jingzhun", roles: [1, 2, 3, 9] },
      children: [{
        path: '/productAnalysis',
        name: 'productAnalysis',
        meta: { title: "商品分析", roles: [1, 2, 3, 9] },
        component: productAnalysis,
        hidden: true
      }, {
        path: '/inventoryAnalysis',
        name: 'inventoryAnalysis',
        meta: { title: "库存分析", roles: [1, 2, 3, 9] },
        component: inventoryAnalysis,
        hidden: true
      }, {
        path: '/procurementAnalysis',
        name: 'procurementAnalysis',
        meta: { title: "采购分析", roles: [1, 2, 3, 9] },
        component: procurementAnalysis,
        hidden: true
      }, {
        path: '/salesAnalysis',
        name: 'salesAnalysis',
        meta: { title: "销售分析", roles: [1, 2, 3, 9] },
        component: salesAnalysis,
        hidden: true
      },
      {
        path: '/takeoutanalysis',
        name: 'takeoutanalysis',
        meta: { title: "外卖分析", roles: [1, 2, 3, 9] },
        component: takeoutanalysis,
        hidden: true
      },
      {
        path: '/employeePerformanceAnalysis',
        name: 'employeePerformanceAnalysis',
        meta: { title: "员工绩效", roles: [1, 2, 3, 9] },
        component: employeePerformanceAnalysis,
        hidden: true
      },
      {
        path: '/customerAnalysis',
        name: 'customerAnalysis',
        meta: { title: "客户分析", roles: [1, 2, 3, 9] },
        component: customerAnalysis,
        hidden: true
      },
      {
        path: '/bigDataScreen',
        name: 'bigDataScreen',
        meta: { title: "数据大屏", roles: [1, 2, 3, 9], noLayout: true, target: '_blank' },
        component: () => import('@/views/bigDataScreen/index'),
        // 新增 meta 标记，表示不显示 layout
        hidden: false
      },
      {
        path: '/attendanceAnalysis',
        name: 'attendanceAnalysis',
        meta: { title: "打卡记录", roles: [1, 2, 3, 9] },
        component: attendanceAnalysis,
        hidden: true
      },
      {
        path: '/dailyReport',
        name: 'dailyReport',
        meta: { title: "资产分析", roles: [1, 2, 3] },
        component: () => import('@/views/dailyReport/index'),
        hidden: true
      },
      {
        path: '/brushAnalysis',
        name: 'brushAnalysis',
        meta: { title: "刷单分析", roles: [1, 2, 3, 9] },
        component: () => import('@/views/brushAnalysis/index'),
        hidden: true
      },

      ],
      hidden: true
    },
    {
      path: '/AiConfiguration',
      component: layout,
      meta: { title: "AI配置", icon: "icon-qunzu", roles: [1, 2, 3, 9]},
      children: [
        {
          path: '/productNameTraining',
          name: 'productNameTraining',
          meta: { title: "品名训练", roles: [2, 3, 9] },
          component: productNameTraining,
          hidden: true
        },
        {
          path: '/groupChatManagement',
          name: 'groupChatManagement',
          meta: { title: "群聊管理", roles: [2, 3, 9] },
          component: groupChatManagement,
          hidden: true
        },
        {
          path: '/shopPush',
          name: 'shopPush',
          meta: { title: "店铺推送", visiable: true, roles: [1, 2, 3, 9] },
          component: () => import('@/views/shopPush/index'),
        }
        ,{
          path: '/styleLibrary',
          name: 'styleLibrary',
          meta: { title: "样式库管理", roles: [1, 2, 3, 9] },
          component: () => import('@/views/styleLibrary/index'),
          hidden: false
        }
      ],
      hidden: true
    },
    {
      path: '/basicConfiguration',
      component: layout,
      meta: { title: "配置", icon: "icon-shezhi", roles: [1, 2, 3, 9] },
      children: [{
        path: '/productClassification',
        name: 'productClassification',
        meta: { title: "商品分类", roles: [1, 9] },
        component: productClassification,
        hidden: true
      }, {
        path: '/platformProducts',
        name: 'platformProducts',
        meta: { title: "商品管理", roles: [1, 9] },  //平台 产品管理
        component: platformProducts,
        hidden: true
      }, {
        path: '/franchiseManagement',
        name: 'franchiseManagement',
        meta: { title: "商户管理", roles: [1, 2, 3, 9] },
        component: franchiseManagement,
        hidden: true
      }, {
        path: '/storeManagement',
        name: 'storeManagement',
        meta: { title: "门店管理", roles: [1, 2, 3, 9] },
        component: storeManagement,
        hidden: true
      }, {
        path: '/personnelManagement',
        name: 'personnelManagement',
        meta: { title: "人员管理", roles: [2, 3, 9] }, //员工管理
        component: personnelManagement,
        hidden: true
      },
      {
        path: '/onlineBanking',
        name: 'onlineBanking',
        meta: { title: "银豹管理", roles: [2, 3, 9] }, //角色权限，账户角色
        component: onlineBanking,
        hidden: true
      },
      {
        path: '/fundAccount',
        name: 'fundAccount',
        meta: { title: "资金账户", roles: [2, 3, 9] },
        component: fundAccount,
        hidden: true
      }, {
        path: '/customerManagement',
        name: 'customerManagement',
        meta: { title: "客户管理", roles: [2, 3, 9] },
        component: customerManagement,
        hidden: true
      }, {
        path: '/supplierManagement',
        name: 'supplierManagement',
        meta: { title: "供应商管理", roles: [2, 3, 9] },
        component: supplierManagement,
        hidden: true
      }, 
      // {
      //   path: '/wxRoomManagement',
      //   name: 'wxRoomManagement',
      //   meta: { title: "微信群管理", roles: [2, 3, 9] },
      //   component: wxRoomManagement,
      //   hidden: true
      // },
      {
        path: '/tradeManagement',
        name: 'tradeManagement',
        meta: { title: "门店指标", roles: [2, 3, 9] },
        component: tradeManagement,
        hidden: true
      },
      {
        path: '/employeeLog',
        name: 'employeeLog',
        meta: { title: "日志查询", roles: [1, 2, 3, 9] }, //员工日志
        component: employeeLog,
        hidden: true
      }, {
        path: '/regionalManagement',
        name: 'regionalManagement',
        meta: { title: "区域管理", roles: [1, 9] }, //员工日志
        component: regionalManagement,
        hidden: true
      }, {
        path: '/weChatUsers',
        name: 'weChatUsers',
        meta: { title: "微信用户", roles: [1, 9] }, //员工日志
        component: weChatUsers,
        hidden: true
      }, {
        path: '/weChatOfficialAccountConfiguration',
        name: 'weChatOfficialAccountConfiguration',
        meta: { title: "公众号配置", roles: [1, 9] }, //员工日志
        component: weChatOfficialAccountConfiguration,
        hidden: true
      }
      , {
        path: '/brandManagement',
        name: 'brandManagement',
        meta: { title: "品牌管理", roles: [1, 2, 3, 9] }, //品牌管理
        component: brandManagement,
        hidden: true
      }, {
        path: '/menuManagement',
        name: 'menuManagement',
        meta: { title: "权限菜单", roles: [1, 2, 3] },
        component: () => import('@/views/menuManagement/index.vue'),
        hidden: true
      },{
        path: '/labelManagement',
        name: 'labelManagement',
        meta: { title: "标签管理", roles: [1, 2, 3, 9] }, //标签管理
        component: labelManagement,
        hidden: true
      }
      ],
      hidden: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js